<div class="card mb-3">
    <div class="card-header">
        <h5>Company Information</h5>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-6">
                <p><strong>Company Name:</strong> {{partner.companyName}}</p>
            </div>
        </div>
    </div>
</div>

<div class="card mb-3">
    <div class="card-header">
        <h5>Legal Information</h5>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-6">
                <p><strong>RCCM:</strong> {{partner.legalInfo.rccm || 'N/A'}}</p>
                <p><strong>NIU:</strong> {{partner.legalInfo.niu || 'N/A'}}</p>
                <p><strong>Business License Number:</strong> {{partner.legalInfo.businessLicenseNumber || 'N/A'}}</p>
            </div>
        </div>
    </div>
</div>

<div class="card mb-3">
    <div class="card-header">
        <h5>Legal Representative</h5>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-6">
                <p><strong>Full Name:</strong> {{partner.legalRepresentative.fullName}}</p>
                <p><strong>Position:</strong> {{partner.legalRepresentative.position || 'N/A'}}</p>
                <p><strong>Phone:</strong> {{partner.legalRepresentative.phoneNumber || 'N/A'}}</p>
            </div>
        </div>
    </div>
</div>

<div class="card mb-3">
    <div class="card-header">
        <h5>Operational Information</h5>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-6">
                <p><strong>Company Email:</strong> {{partner.operationalInfo.companyEmail || 'N/A'}}</p>
                <p><strong>Company Phone:</strong> {{partner.operationalInfo.companyPhoneNumber || 'N/A'}}</p>
            </div>
            <div class="col-md-6">
                <p><strong>Country:</strong> {{partner.operationalInfo.country || 'N/A'}}</p>
                <p><strong>City:</strong> {{partner.operationalInfo.city || 'N/A'}}</p>
                <p><strong>Address:</strong> {{partner.operationalInfo.address || 'N/A'}}</p>
            </div>
        </div>
        <div class="row mt-3" *ngIf="partner.operationalInfo.description">
            <div class="col-12">
                <p><strong>Description:</strong></p>
                <p>{{partner.operationalInfo.description}}</p>
            </div>
        </div>
    </div>
</div>

<div class="card mb-3" *ngIf="partner.paymentInfo">
    <div class="card-header">
        <h5>Payment Information</h5>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-6">
                <p><strong>Payment Type:</strong>
                    {{partner.paymentInfo.paymentType === 'MOBILE_MONEY' ? 'Mobile Money' : 'Bank Transfer'}}
                </p>
            </div>
        </div>

        <!-- Mobile Money Details -->
        <div *ngIf="partner.paymentInfo.paymentType === 'MOBILE_MONEY'">
            <div class="row">
                <div class="col-md-6">
                    <p><strong>Provider:</strong> {{partner.paymentInfo.mobileMoneyProvider || 'N/A'}}</p>
                    <p><strong>Mobile Number:</strong> {{partner.paymentInfo.mobileMoneyNumber || 'N/A'}}</p>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-12">
                    <p><strong>Verification Status:</strong>
                        <span class="badge" [ngClass]="partner.paymentInfo.numberVerified ? 'bg-success' : 'bg-warning'">
                            {{partner.paymentInfo.numberVerified ? 'Verified' : 'Not Verified'}}
                        </span>
                    </p>
                </div>
            </div>
        </div>

        <!-- Bank Details -->
        <div class="row" *ngIf="partner.paymentInfo.paymentType === 'BANK'">
            <div class="col-md-6">
                <p><strong>Bank Name:</strong> {{partner.paymentInfo.bankName || 'N/A'}}</p>
                <p><strong>Account Number:</strong> {{partner.paymentInfo.accountNumber || 'N/A'}}</p>
            </div>
            <div class="col-md-6">
                <p><strong>Account Holder:</strong> {{partner.paymentInfo.accountHolderName || 'N/A'}}</p>
            </div>
        </div>
    </div>
</div>

<!-- Documents Section -->
<div class="card mb-3">
    <div class="card-header">
        <h5>Documents</h5>
    </div>
    <div class="card-body">
        <div *ngIf="!partner.documents || partner.documents.length === 0" class="text-muted">
            No documents uploaded
        </div>
        <div class="row" *ngIf="partner.documents && partner.documents.length > 0">
            <div class="col-md-6" *ngFor="let doc of partner.documents">
                <div class="mb-3">
                    <p><strong>{{ getDocumentTypeLabel(doc.documentType) }}:</strong></p>
                    <p *ngIf="doc.deliveredAt"><strong>Delivered At:</strong> {{doc.deliveredAt}}</p>
                    <button class="btn btn-primary" (click)="downloadDocument(doc.id, doc.documentPath)">
                        Download Document
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
